import { StyleSheet } from "react-native";
import { Card, type CardProps } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

type Props = Omit<CardProps, "mode" | "elevation">;

export const FlatCard = (props: Props) => {
	const theme = useAppTheme();
	return (
		<Card
			{...props}
			mode="contained"
			style={{
				backgroundColor: theme.colors.surface,
				...StyleSheet.flatten(props.style),
			}}
		/>
	);
};
